export default "__VITE_ASSET__DtWYaRH2__"